export class CalendarEventType {
    title: string;
    color = 0;
    id = 0;
}
